var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4758_92885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.67251 9.00032C9.61391 8.99869 9.55808 9.00336 9.50672 9.01307C9.40398 9.0325 9.31947 9.06941 9.24527 9.12785C9.09687 9.24474 8.99658 9.43901 8.99658 9.70813V15.1156V18.8778V24.2916C8.99658 24.7625 9.26363 25.0138 9.67251 24.9994C9.73046 24.9974 9.79199 24.9837 9.85743 24.9675L14.5826 23.807C15.1023 23.6793 15.5582 23.1018 15.5582 22.5635V20.6059V18.508H13.2817C12.8549 18.508 12.5038 18.157 12.5038 17.73V16.2697C12.5038 15.8427 12.8549 15.4918 13.2817 15.4918H15.5582V13.3875V11.4362C15.5582 10.898 15.1022 10.314 14.5826 10.1864L9.85743 9.02583C9.79246 9.00987 9.73111 9.00195 9.67251 9.00032ZM18.8613 12.8518C18.7846 12.8533 18.7111 12.887 18.6509 12.9475L17.6178 13.9741C17.4944 14.0981 17.4944 14.2902 17.6178 14.4141L18.7593 15.5619C18.7903 15.595 18.8112 15.6363 18.8192 15.6809C18.8273 15.7256 18.8222 15.7716 18.8047 15.8134C18.7872 15.8552 18.7579 15.8911 18.7204 15.9166C18.6829 15.9421 18.6388 15.9563 18.5935 15.9573H13.2817C13.1078 15.9573 12.9756 16.0938 12.9756 16.2697V17.73C12.9756 17.9059 13.1078 18.0361 13.2817 18.0361H18.6062C18.6529 18.0359 18.6985 18.0496 18.7373 18.0755C18.7761 18.1013 18.8063 18.1381 18.8241 18.1812C18.8419 18.2243 18.8464 18.2718 18.8372 18.3175C18.8279 18.3632 18.8052 18.405 18.772 18.4378L17.6178 19.5984C17.4943 19.7223 17.4943 19.908 17.6178 20.032L18.6509 21.065C18.7736 21.1882 18.9401 21.1754 19.1036 21.0458L21.8838 18.2592L22.9105 17.2262C23.0342 17.102 23.0344 16.9102 22.9105 16.7862L21.8838 15.7532L19.0845 12.9474C19.023 12.8857 18.9464 12.8518 18.8677 12.8518C18.8656 12.8518 18.8634 12.8519 18.8613 12.8518Z",
    fill: "#373D3F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4758_92885",
    x: -2.57143,
    y: -1.57143,
    width: 37.1429,
    height: 37.1429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.28571
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.141176 0 0 0 0 0.152941 0 0 0 0 0.168627 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4758_92885"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4758_92885",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.be93adbce9fee2e6e4ef931c2af19ffe.svg";
export { ForwardRef as ReactComponent };